module.exports = __webpack_public_path__ + "e1a5daa049d2492c935f01f668ee21a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/favorite/tom-chua.jpg
// module id = ./assets/images/favorite/tom-chua.jpg
// module chunks = 0